import { EventType, Features, SourcePages } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../types';

export type LeadFormAction =
  | 'name_field'
  | 'email_field'
  | 'phone_field'
  | 'lead_form_submit'
  | 'terms_of_use'
  | 'privacy_policy'
  | 'marketing_opt_in'
  | 'marketing_opt_out';

interface LeadFormEventInfo extends VehicleEventInfo {
  action: LeadFormAction;
  sourcePage: SourcePages;
}

const event = ({ action, trackingParams, sourcePage }: LeadFormEventInfo): EventData => {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature: Features.leadForm,
    engagement_type: `${action}_tap`,
    event_context: {
      tracking_params: trackingParams,
    },
  };
};

export default event;
